import { render, staticRenderFns } from "./image-dialog.vue?vue&type=template&id=5f22cd07&"
import script from "./image-dialog.vue?vue&type=script&lang=js&"
export * from "./image-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports